import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: theme.palette.grey[100],
    borderRadius: '20px 20px 0px 0px',
    height: '100vh',
    BoxShadow: 'none'
  },
  selectBoxes: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    // borderRadius: '40px 40px 0px 0px',
    width: '100%'
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  oneBoxInRow: {
    paddingLeft: 10,
    paddingRight: 15,
    width: '100%',
    paddingBottom: 30,
    position: 'absolute',
    bottom: 0,
    top: 0,
    // height: 650,
    display: 'flex',
    flexDirection: 'column',
    overflowX: 'hidden',
    justifyContent: 'space-between',
    '& div': {
      '& label': {
        paddingLeft: 0
      }
    }
  },
  buttonOfDate: {
    width: 282,
    height: 50,
    textAlign: 'left',
    '& span': {
      margin: '12px 0px',
      fontSize: 14
    }
  },
  dateRangePicker: {
    position: 'absolute',
    right: -2,
    top: -8,
    zIndex: 1
  },
  textShowOnButtonParrent: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  textShowOnButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    width: '100%',
    marginLeft: -48
  },
  typographyOfButton: {
    color: `${theme.palette.grey[200]} !important`
  },
  typographyOfButtonAfterSelectDate: {
    color: `${theme.palette.grey[300]} !important`,
    fontSize: 12,
    fontWeight: 500
  },
  typographyOfButtonAfterSelectDateForArrivalDateAndDeparture: {
    color: `${theme.palette.grey[300]} !important`,
    fontSize: 13,
    fontWeight: 700
  },

  ButtonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    width: '100%',
    marginTop: 20,
    height: 20,
    '& Button:first-child': {
      minHeight: 38,
      width: 116,
      fontSize: 16,
      color: `${theme.palette.grey[700]}`
    },
    '& Button:last-child': {
      minHeight: 38,
      width: 116,
      fontSize: 16,
      color: `${theme.palette.primary.main}`
    }
  },
  typographyOfTitle: {
    paddingBottom: 10
  },
  switchContainer: {
    display: 'flex',
    marginTop: 15,
    marginBottom: 15
  },
  menuItemRow: { display: 'flex', alignItems: 'center' }
}))

export default useStyles
